import React from 'react';
import { graphql } from 'gatsby';

import Pancake from './Pancake';
import PancakeIntro from '../PancakeIntro';
import Card from '../Card';
import Button from '../Button';
import GitHubStar from '../GitHubStar';
import SanityPortableText from '../SanityPortableText';

import './Explore.scss';

const Explore = (props) => {
  const {
    title,
    text,
    textColumn,
    customCards,
    theme,
    include = ['Tour Center', 'Blogs', 'Self-hosted'],
  } = props;

  const defaultCards = [
    {
      cardTitle: 'Open Source',
      cardText: (
        <>
          <p>Use the pieces of Okteto that are right for you</p>
          <div className="GitHubStarWrapper">
            <GitHubStar />
          </div>
        </>
      ),
      cardCallToAction: {
        label: 'GitHub',
        url: 'https://github.com/okteto/okteto/',
      },
    },
    {
      cardTitle: 'Tour Center',
      cardText: (
        <>
          <p>Explore Okteto Platform features through guided tours</p>
        </>
      ),
      cardCallToAction: {
        label: 'Explore',
        url: '/product-tour-center',
      },
    },
    {
      cardTitle: 'Docs',
      cardText: <p>Go deeper on Okteto Development Environments</p>,
      cardCallToAction: {
        label: 'Documentation',
        url: '/docs/getting-started/',
      },
    },
    {
      cardTitle: 'SaaS',
      cardText: <p>Our hosted solution for individuals and teams</p>,
      cardCallToAction: {
        label: 'Try free',
        url: 'https://cloud.okteto.com',
      },
    },
    {
      cardTitle: 'Self-hosted',
      cardText: <p>Run Okteto on your own infrastructure</p>,
      cardCallToAction: {
        label: 'Get a demo',
        url: '/get-demo/',
      },
    },
    {
      cardTitle: 'Get Started',
      cardText: (
        <p>
          Okteto Development Experience Automation hosted on your infrastructure
        </p>
      ),
      cardCallToAction: {
        label: 'Sign up',
        url: '/free-trial/',
      },
    },
    {
      cardTitle: 'Blogs',
      cardText: (
        <p>Resources for platform engineering teams designing modern DevX</p>
      ),
      cardCallToAction: {
        label: 'Read more',
        url: '/blog/',
      },
    },
    {
      cardTitle: 'Book a demo',
      cardText: (
        <p>Tell us about your use case and we’ll show you how to automate it</p>
      ),
      cardCallToAction: {
        label: 'Schedule',
        url: '/get-demo/',
      },
    },
  ];

  const finalCards =
    customCards?.length > 0
      ? customCards
      : defaultCards.filter((card) => include.includes(card.cardTitle));

  return (
    <Pancake className="ExploreSection" theme={theme}>
      <div className="ContainerLegacy">
        {(title || text) && <PancakeIntro title={title} text={text} />}
        <div className="ExploreGrid">
          {textColumn && (
            <div>
              <SanityPortableText blocks={textColumn} />
            </div>
          )}
          {finalCards.map((card, index) => {
            const theme =
              index === 0
                ? 'Light'
                : index === 1
                ? 'Green'
                : index === 2
                ? 'Blue'
                : null;

            return (
              <Card theme={theme} clickable key={index}>
                <Card.Title>{card.cardTitle}</Card.Title>
                {/* If cardText is an array, it’s coming from Sanity. We need `SanityPortableText` to render the text correctly */}
                {Array.isArray(card.cardText) ? (
                  <Card.Content>
                    <SanityPortableText blocks={card.cardText} />
                  </Card.Content>
                ) : (
                  <Card.Content>{card.cardText}</Card.Content>
                )}
                {card.cardCallToAction?.url && (
                  <Card.CTA>
                    <Button
                      className={`transparent full ${
                        index !== 2 ? 'corporate-light' : ''
                      }`}
                      to={card.cardCallToAction?.url}
                      arrow
                    >
                      {card.cardCallToAction?.label}
                    </Button>
                  </Card.CTA>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeExplore on SanityExplore {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    theme
    _rawText(resolveReferences: { maxDepth: 1000 })
    cards {
      cardTitle
      cardText: _rawCardText
      cardCallToAction {
        label
        url
      }
    }
  }
`;

export default Explore;
